import { Component, Vue, Watch } from 'vue-property-decorator';

import '@/styles/tplus_inputs.scss'

import {Purchase, PurchaseTotal, UniversalData} from "@/services/models-service";
import dicts_cache_service from "@/services/dicts_cache_service";
import {HeatCarrier} from "@/services/data/heat_carrier_service";
import _ from "lodash";
import PresetService from "@/services/user_preset_service";
import {months_list, periods} from "@/constants";
import { aggregate_periods } from '@/constants';
import { EcoObjectType } from '@/services/models-service';

class Item {
  name: string;
  display: string;
}

@Component({
  name: 'CommonInputMixin'
})

export default class extends Vue {
  // Сервисы
  public preset_service = PresetService;

  public block_ds: any[] = [];
  public set_periods: any = [];
  public selected_periods: any = [];
  public listToAggregate: any = [];
  public aggregatePeriods: any = [];
  public facility_ds: any[] = [];

  // Флаги
  public rowVisible: any = {};
  // флаг первоначального подсчета вторичной срезки
  public initSecondary: boolean = false;
  // флаг видимости доп срезки в рамках сессии загрузки данных, устанавливается после нажатия кнопки "Загрузить" в
  // заваисмости от данных в HeaderSet, если флаг включается то столбцы данных доп. срезки будут видимыми не зависимо от манипуляций в заголовке
  public secondaryCutIsVisible = false;
  //флаг уведомления об отсутствии доступных блоков
  public showNoBlocks: boolean = false;
  //флаг уведомления об отсутствии тарифов/контрагентов
  public showNoTariffs: boolean = false;

  //Данные страницы
  public totalData: any = {};
  public secondaryTotalData: any = {};

  //отслеживание изменений
  public changed: any[] = [];
  public changedData: any = {};

  // данные словарей
  public allHeatCarrier: HeatCarrier[] = [];
  public months: string[] = periods; // массив кодов месяцев

  public hideHeader: boolean = true;
  public acceptsIsReady: boolean = true; // флаг акцепты загружены

  get route() {
    return this.$route.name
  }
  // массив для отслеживания редактирования тарифов
  public tariffIds: string[] = [];

  public needRecalc: number | null = null;
  public choiсe: string | null = null;
  public tariffForRollback: string = '';

  created() {
    if(!_.isNil(sessionStorage.getItem(`hideHeader_${this.route}`))) {
      const match = sessionStorage.getItem(`hideHeader_${this.route}`);
      if(match) {
        const settings = JSON.parse(match);
        if(settings.user_id === localStorage.getItem('user_id')) this.hideHeader = (settings.state === 'true');
      }
    }
  }

  switchToogle() {
    this.hideHeader = !this.hideHeader;
    sessionStorage.setItem(`hideHeader_${this.route}`, `{"user_id": "${localStorage.getItem('user_id')}", "state": "${this.hideHeader}"}`);
  }

  mounted() {
    this.allHeatCarrier = dicts_cache_service.heat_carrier;
  }

  public keys = [
    {id: 1, name: 'first'},
    {id: 2, name: 'second'},
    {id: 3, name: 'third'},
    {id: 4, name: 'fourth'},
    {id: 5, name: 'fifth'},
    {id: 6, name: 'sixth'},
    {id: 7, name: 'steam_total'},
    {id: 8, name: 'total'}
  ]

  public month: any = {
    1: 'january',
    2: 'february',
    3: 'march',
    4: 'april',
    5: 'may',
    6: 'june',
    7: 'july',
    8: 'august',
    9: 'september',
    10: 'october',
    11: 'november',
    12: 'december'
  }

  calculateSum(target: any) {
    let total_vol_te = 0;
    let total_cost_te = 0;
    let total_price_te = 0;
    let total_vol_power = 0;
    let total_cost_power = 0;
    let total_price_power = 0;
    let total_cost_delta_te = 0;
    let total_cost_delta_power = 0;
    let total_price_total = 0;
    let total_cost_total = 0;
    for (let key in target) {
      this.keys.forEach(k => {
        if(k.name === key) {
          if (!(k.name === 'first' || k.name === 'total' || k.name === 'steam_total')) {
            total_vol_te += target[key].vol_te;
            total_cost_te += target[key].cost_te;
            total_vol_power += target[key].vol_power;
            total_cost_power += target[key].cost_power;
            total_cost_delta_te += target[key].cost_delta_te;
            total_cost_delta_power += target[key].cost_delta_power;
            total_price_te = (total_cost_te + total_cost_delta_te) / total_vol_te || 0;
            total_price_power = (total_cost_power + total_cost_delta_power) * 1000 / total_vol_power || 0;
            total_cost_total += target[key].cost_total;
            total_price_total = (total_cost_total + total_cost_delta_te + total_cost_delta_power) / (total_vol_te + total_vol_power / 1000) || 0;
          }
        }
      });
    }
    target.steam_total.vol_te = total_vol_te;
    target.total.vol_te = target.steam_total.vol_te + target.first.vol_te;
    target.steam_total.cost_te = total_cost_te;
    target.total.cost_te = target.steam_total.cost_te + target.first.cost_te;
    target.steam_total.vol_power = total_vol_power;
    target.total.vol_power = target.steam_total.vol_power + target.first.vol_power;
    target.steam_total.cost_power = total_cost_power;
    target.total.cost_power = target.steam_total.cost_power + target.first.cost_power;
    target.steam_total.cost_delta_te = total_cost_delta_te;
    target.total.cost_delta_te = target.steam_total.cost_delta_te + target.first.cost_delta_te;
    target.steam_total.cost_delta_power = total_cost_delta_power;
    target.total.cost_delta_power = target.steam_total.cost_delta_power + target.first.cost_delta_power;
    target.steam_total.price_te = (target.steam_total.cost_te + target.steam_total.cost_delta_te) / target.steam_total.vol_te || 0;
    target.total.price_te = (target.total.cost_te + target.total.cost_delta_te) / target.total.vol_te || 0;
    target.steam_total.price_power = (target.steam_total.cost_power + target.steam_total.cost_delta_power) * 1000 / target.steam_total.vol_power || 0;
    target.total.price_power = (target.total.cost_power + target.total.cost_delta_power) * 1000 / target.total.vol_power || 0;
    target.steam_total.cost_total = total_cost_total;
    target.total.cost_total = target.steam_total.cost_total + target.first.cost_total;
    target.steam_total.price_total = (target.steam_total.cost_total + target.steam_total.cost_delta_te + target.steam_total.cost_delta_power) /
    (target.steam_total.vol_te + target.steam_total.vol_power / 1000) || 0;
    target.total.price_total = (target.total.cost_total + target.total.cost_delta_te + target.total.cost_delta_power) /
    (target.total.vol_te + target.total.vol_power / 1000) || 0;
  }

  checkEmptyRows(block: string) {
    const seekKeys = ['vol_te', 'vol_power','cost_te', 'cost_power']
    const rowsVisible: any = {}
    this.keys.forEach((row) => {
      if(row.name === 'total' || row.name === 'steam_total') {
        return
      }
      if(row.name === 'total' || row.name === 'steam_total') {
        return
      }
      for(let period in this.totalData[block]) {
        for(let key in seekKeys) {
          if(this.totalData[block][period][row.name][seekKeys[key]] !== 0) {
            rowsVisible[row.name] = true;
            return
          }
          if(this.secondaryTotalData.hasOwnProperty(block) && this.secondaryTotalData[block][period][row.name][seekKeys[key]] !== 0) {
            rowsVisible[row.name] = true;
            return
          }
          if(this.totalData[block][period][row.name][seekKeys[key]] !== 0) {
            rowsVisible[row.name] = true;
            return
          }
          if(this.secondaryTotalData.hasOwnProperty(block) && this.secondaryTotalData[block][period][row.name][seekKeys[key]] !== 0) {
            rowsVisible[row.name] = true;
            return
          }
        }
      }
      rowsVisible[row.name] = false;
      return
    });
    return rowsVisible
  }

  seekChanges(changes: any) {
    this.rowVisible[changes.block] = this.checkEmptyRows(changes.block);
    this.calculateSum(this.totalData[changes.block][changes.period]);
    if(this.preset_service.currentPreset?.id_secondary_cut && this.initSecondary) {
      this.calculateSum(this.secondaryTotalData[changes.block][changes.period]);
      this.initSecondary = false;
    }
    if(changes.block !== 'total' && !aggregate_periods.hasOwnProperty(changes.period)) this.changedData = _.cloneDeep(this.totalData[changes.block][changes.period]);
    if(!this.changed.find(c => c.block === changes.block && c.period ===  changes.period) ) {
      this.changed.push(changes);
    }
  }

  async getSavedData(changes: any, target: any, get_func: any, tariffs: any) {
    if(this.preset_service.currentPreset.id_cut && this.preset_service.currentPreset.id_eco_facility) {
      const response: any = await  get_func([this.preset_service.currentPreset.id_cut,], this.preset_service.currentPreset.id_eco_facility, this.months);
      let savedData: any[] = [];
      if (response) {
        if(response[this.preset_service.currentPreset.id_cut]) {
          savedData = response[this.preset_service.currentPreset.id_cut] || [];
        }
      }
      changes.forEach((changed: any) => {
        if (changed.block === 'total') {
          return
        }
        periods.forEach((month: string) => {
          target[changed.block][month] = [];
        });
        savedData.forEach((row: UniversalData)  => {
          if(row.block === changed.block &&  target[row.block].hasOwnProperty(row.month)) {
            target[row.block][row.month].push(row);
          }
        });
      });
      for(let block in target) {
        for(let month in target[block]) {
          target[block][month].sort((data1: any, data2: any) => {

            if (tariffs[data1.id_tarif].id_heat_carrier < tariffs[data2.id_tarif].id_heat_carrier) return -1;
            if (tariffs[data1.id_tarif].id_heat_carrier > tariffs[data2.id_tarif].id_heat_carrier) return 1;


            if (data1.id_contractor < data2.id_contractor) return -1;
            if (data1.id_contractor > data2.id_contractor) return 1;

            if (data1.id_tarif < data2.id_tarif) return -1;
            if (data1.id_tarif > data2.id_tarif) return 1;
  
            return 0;
          });
        }
      }
    }
  }

  async getSavedTotalData (changes: any, get_func: any) {
    if (this.preset_service.currentPreset.id_cut && this.preset_service.currentPreset.id_eco_facility) {
      let savedTotalData: any[] = [];
      const blockToDraw = this.block_ds.map( b => b.name);
      const changedBlocks = [...new Set(changes.map((c: any) => c.block))];
      const response: any = await  get_func(this.preset_service.currentPreset.id_cut, this.preset_service.currentPreset.id_eco_facility, changedBlocks, this.selected_periods);
      if (response) {
        savedTotalData = response[this.preset_service.currentPreset.id_cut];
      }
      savedTotalData.forEach((row: PurchaseTotal)  => {
        let match: boolean = true;
        if (row.is_total) {
          row.block = 'total';
        } else {
          match = blockToDraw.includes(row.block);
        }
        if (match && this.totalData[row.block].hasOwnProperty(row.month)) {
          if (row.is_total_block) {
            this.totalData[row.block][row.month]['total'] = row;
          }
          else if (row.is_steam_total_block) {
            this.totalData[row.block][row.month]['steam_total'] = row;
          }
          else if (row.id_heat_carrier) {
            const idx = this.keys.find(k => k.id === row.id_heat_carrier)
            if (idx) {
              this.totalData[row.block][row.month][idx.name] = row;
            }
          }
        }
      });
    }
  }


  createTotalStructure() {
    let structure: any = {};
    //создаем структуру данных
    this.block_ds.forEach((block: Item) =>{
      structure[block.name] = {};
    });
    this.selected_periods.forEach((period: string)=> {
      if(aggregate_periods.hasOwnProperty(period) && !this.aggregatePeriods.includes(period)) {
        this.aggregatePeriods.push(period);
        this.listToAggregate.push(...aggregate_periods[period]);
      }
      for(let block in structure) {
        structure[block][period] = {};
        this.keys.forEach(k =>{
          let row = new PurchaseTotal()
          row.block = block;
          row.month = period;
          if(k.name === 'total') {
            row.is_total_block = true;
          } else if (k.name === 'steam_total') {
            row.is_steam_total_block = true;
          } else {
            row.id_heat_carrier = k.id;
          }
          if(this.preset_service.currentPreset && this.preset_service.currentPreset.id_cut && this.preset_service.currentPreset.id_eco_facility && this.preset_service.currentPreset.id_eco_heat_node) {
            row.id_cut = this.preset_service.currentPreset.id_cut;
            row.id_eco_facility = this.preset_service.currentPreset.id_eco_facility;
            row.id_eco_heat_node = this.preset_service.currentPreset.id_eco_heat_node;
          }
          structure[block][period][k.name] = row;
        });
      }
    });
    return structure;
  }

  createStructure() {
    //создаем структуру данных
    let structure: any = {};
    this.block_ds.forEach((block: Item) =>{
      if(block.name === 'total') return;
      structure[block.name] = {};
    });
    let periodsList = this.months.concat(this.aggregatePeriods);
    periodsList.forEach((period: string)=> {
      for(let key in structure) {
        structure[key][period] = [];
      }
    });
    console.log("Q!12345678", structure)
    return structure;
  }

  parseTotalData(target: any, data: any) {
    // распарсиваем данные по блокам и периодам
    const blockToDraw = this.block_ds.map( b => b.name);
    data.forEach((row: PurchaseTotal)  => {
      let match: boolean = true;
      if (row.is_total) {
        row.block = 'total';
      } else {
        match = blockToDraw.includes(row.block);
      }
      if (match && target[row.block].hasOwnProperty(row.month)) {
        if (row.is_total_block) {
          target[row.block][row.month]['total'] = row;
        }
        else if (row.is_steam_total_block) {
          target[row.block][row.month]['steam_total'] = row;
        }
        else if (row.id_heat_carrier) {
          const idx = this.keys.find(k => k.id === row.id_heat_carrier)
          if (idx) {
            target[row.block][row.month][idx.name] = row;
          }
        }
      }
        if(this.listToAggregate.includes(row.month)) {
          this.aggregatePeriods.forEach((period: string) => {
            if(aggregate_periods.hasOwnProperty(period) && aggregate_periods[period].includes(row.month)) {
              if(row.is_total_block) {
                const grouped_total_row = target[row.block][period]['total']
                grouped_total_row.vol_te += row.vol_te;
                grouped_total_row.vol_power += row.vol_power;
                grouped_total_row.cost_te += row.cost_te;
                grouped_total_row.cost_power += row.cost_power;
                grouped_total_row.cost_delta_power += row.cost_delta_power;
                grouped_total_row.cost_delta_te += row.cost_delta_te;
                grouped_total_row.cost_total += row.cost_total;
                grouped_total_row.price_te = (grouped_total_row.cost_te + grouped_total_row.cost_delta_te) / grouped_total_row.vol_te || 0;
                grouped_total_row.price_power = (grouped_total_row.cost_power + grouped_total_row.cost_delta_power) * 1000 / grouped_total_row.vol_power || 0;
                grouped_total_row.price_total = (grouped_total_row.cost_total + grouped_total_row.cost_delta_te + grouped_total_row.cost_delta_power) / (grouped_total_row.vol_te + grouped_total_row.vol_power / 1000) || 0;
              }
              if(row.is_steam_total_block) {
                const grouped_steam_row = target[row.block][period]['steam_total']
                grouped_steam_row.vol_te += row.vol_te;
                grouped_steam_row.vol_power += row.vol_power;
                grouped_steam_row.cost_te += row.cost_te;
                grouped_steam_row.cost_power += row.cost_power;
                grouped_steam_row.cost_delta_power += row.cost_delta_power;
                grouped_steam_row.cost_delta_te += row.cost_delta_te;
                grouped_steam_row.cost_total += row.cost_total;
                grouped_steam_row.price_te = (grouped_steam_row.cost_te + grouped_steam_row.cost_delta_te) / grouped_steam_row.vol_te || 0;
                grouped_steam_row.price_power = (grouped_steam_row.cost_power + grouped_steam_row.cost_delta_power) * 1000 / grouped_steam_row.vol_power || 0;
                grouped_steam_row.price_total = (grouped_steam_row.cost_total + grouped_steam_row.cost_delta_te + grouped_steam_row.cost_delta_power) / (grouped_steam_row.vol_te + grouped_steam_row.vol_power / 1000) || 0;
              }
              if(row.id_heat_carrier) {
                const idx = this.keys.find(k => k.id === row.id_heat_carrier)
                if (idx) {
                  const grouped_row = target[row.block][period][idx.name]
                  grouped_row.vol_te += row.vol_te;
                  grouped_row.vol_power += row.vol_power;
                  grouped_row.cost_te += row.cost_te;
                  grouped_row.cost_power += row.cost_power;
                  grouped_row.cost_delta_power += row.cost_delta_power;
                  grouped_row.cost_delta_te += row.cost_delta_te;
                  grouped_row.cost_total += row.cost_total;
                  grouped_row.price_te = (grouped_row.cost_te + grouped_row.cost_delta_te) / grouped_row.vol_te || 0;
                  grouped_row.price_power = (grouped_row.cost_power + grouped_row.cost_delta_power) * 1000 / grouped_row.vol_power || 0;
                  grouped_row.price_total = (grouped_row.cost_total + grouped_row.cost_delta_te + grouped_row.cost_delta_power) / (grouped_row.vol_te + grouped_row.vol_power / 1000) || 0;
                }
              }
            }
          });
        }
    });
  }

  parseData(target: any, data: any, tariffs: any) {
    // распарсиваем данные по блокам и периодам
    data.forEach((row: Purchase)  => {
      const match = this.block_ds.find( b => b.name === row.block);
      if(match && target[row.block].hasOwnProperty(row.month)) {
        target[row.block][row.month].push(row);
      }
      // добавляем тариф в массив для отслеживания редактирования тарифов
      if (!this.tariffIds.includes(row.id_tarif)) {
        this.tariffIds.push(row.id_tarif);
      }
    });
    for(let block in target) {
      for(let month in target[block]) {
        target[block][month].sort((data1: any, data2: any) => {
          if (tariffs[data1.id_tarif].id_heat_carrier < tariffs[data2.id_tarif].id_heat_carrier) return -1;
          if (tariffs[data1.id_tarif].id_heat_carrier > tariffs[data2.id_tarif].id_heat_carrier) return 1;

          if (data1.id_contractor < data2.id_contractor) return -1;
          if (data1.id_contractor > data2.id_contractor) return 1;

          if (data1.id_tarif < data2.id_tarif) return -1;
          if (data1.id_tarif > data2.id_tarif) return 1;
          
          return 0;
        });
      }
    }

    if(this.aggregatePeriods.length > 0) {
      this.aggregatePeriods.forEach((period: string) => {
        for(let block in target) {
          for(let i=0; i < target[block]['january'].length; i++ ) {
            const row = new UniversalData();
            row.id_contractor = target[block]['january'][i].id_contractor;
            row.id_tarif = target[block]['january'][i].id_tarif;
            for(let month in aggregate_periods[period]) {
              const month_name = aggregate_periods[period][month];
              row.vol_te += target[block][month_name][i].vol_te;
              row.vol_power += target[block][month_name][i].vol_power;
              row.cost_te += target[block][month_name][i].cost_te;
              row.cost_power += target[block][month_name][i].cost_power;
              row.cost_delta_power += target[block][month_name][i].cost_delta_power;
              row.cost_delta_te += target[block][month_name][i].cost_delta_te;
              row.cost_total += target[block][month_name][i].cost_total;
            }
            target[block][period].push(row);
          }
        }
      });
    }
  }

  resendFacilities(facilities: any) {
    this.facility_ds = facilities
  }

  tarifChangeHandler(idx: number, newTariff: string, oldTariff: string, block: string) {
    if (!_.isNil(idx)) {
      this.needRecalc = null;
      this.choiсe = null;
      this.tariffForRollback = oldTariff;
      this.choicePopup.idx = idx;
      this.choicePopup.block = block;
      this.choicePopup.tariff = newTariff;
      this.choicePopup.visible = true;
    }
  }

  public choicePopup: any = {
    visible: false,
    idx: null,
    block: '',
    tariff: ''
  }

  onAcceptLoaded(value: boolean) {
    this.acceptsIsReady = value;
  }
}
